// How a surface document URL is resolved per target. Desktop serves from the
// locked-down `plugin:` origin. Web parity (a dedicated sandbox sub-origin) is a
// documented follow-up; see webSurfaceSrc.

/** plugin://<id>/<path> served by apps/app src-tauri plugins.rs with the
 *  per-surface CSP. The leading slash on `path` is normalized away. */
export function desktopSurfaceSrc(pluginId: string, path: string): string {
  return `plugin://${pluginId}/${path.replace(/^\/+/, '')}`;
}

/**
 * FOLLOW-UP (web parity, not built in this slice): on the hosted web build a
 * surface must load from a dedicated sandbox sub-origin serving the same
 * per-surface CSP as plugins.rs (no same-origin with the host). Until that lands,
 * custom surfaces are desktop-only. See the plan's Task 9.
 */
export function webSurfaceSrc(_pluginId: string, _path: string): string {
  throw new Error('custom surfaces are not yet served on the web target');
}
